import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverTimelineDtoAdmin } from '@/backend/market'
import { DriverTimeLineEntity } from '../../domain/entities/DriverTimeLineEntity'

export class DriverTimeLineModel extends DriverTimeLineEntity {
  constructor(dataDto: DriverTimelineDtoAdmin) {
    super()
    mapEntityProperties<DriverTimeLineEntity>(this, dataDto)
  }
}
